import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { CloseIcon } from '../../../assets'
import { CustomReactSelect } from '../../shared'
import { aggFunctionOptions, triggerComparisons } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getDataInputs } from '../../../redux/thunks/triggerThunk';
import { getSelectedForField } from '../../../redux/reducers/queriesReducer';

const QueryBuilders = (props) => {
    const { handleRowDelete, condition, onTriggerRowChange, selected} = props
    const dispatch = useDispatch()
    const { company } = useSelector(state => state.company)
    const { dataInputs } = useSelector(state => state.query)

    useEffect(() => {
        if(company.id){
            dispatch(getDataInputs({companyId: company.id}));
        }
    },[company.id])
     const handleAggregateBy = (option) => {
        onTriggerRowChange({
            ...selected,
            agg_function: option.value
        })

    } 

    const handleChangeDataInput = (option) => {
        onTriggerRowChange({
            ...selected,
            data_input: option.value,
            option: option,
        })

    } 
    const handleOverDaysChange = (e) => {
        onTriggerRowChange({
            ...selected,
            agg_days: e.target.value,
        })

    } 

    const handleValueChange = (e) => {
        onTriggerRowChange({
            ...selected,
            value: e.target.value,
        })

    } 

    const handleComparisonChange = (option) => {
        onTriggerRowChange({
            ...selected,
            operator:option.value,
        })

    }
    const handleDelete = (id) => {
        handleRowDelete(id)
    }
  return (
    <Box>
         <Typography className='mt-20px mb-20px text-500fw-18fs-28lh' >{condition}</Typography>
      <Box className="odd-row-background br-16px padding-16px">
         
          {/* Aggregate By */}
          <Box className='flex-row gap-24' >
              <CustomReactSelect
                  label='Aggregate By'
                  options={aggFunctionOptions}
                  handleFilter={handleAggregateBy}
                  placeholder='Last Data Point'
                  selectedOption={aggFunctionOptions.find(
                      o => o.value === selected.agg_function
                  )}
              />
              <Box className='cursor-pointer' >
                  <CloseIcon color="#98A2B3" width='12' height='12' onClick={handleDelete} />
              </Box>
          </Box>

          {/* For Field  coming from api*/}
          <Box className='padding-tb-24-rl-0' >
              <CustomReactSelect
                  label='For Field'
                  options={dataInputs}
                  handleFilter={handleChangeDataInput}
                  selectedOption={selected.data_input === undefined
                      ? null
                      : getSelectedForField(dataInputs, selected.data_input)
                  }
                  placeholder={<div>Select</div>}
              />
          </Box>

          <Box>
              <Grid className='flex-row' container spacing={'24px'} >
                  <Grid item xs={4}>
                      <label>
                          <Typography className='metrics-dropdown-title'>Over # days</Typography>

                      </label>
                      <input
                          className='custom-text-field text-sm-regular'
                          type='text'
                          placeholder=''
                          onChange={handleOverDaysChange}
                          value={selected.agg_days || ''}

                      />
                  </Grid>
                  <Grid item xs={4}>
                      <CustomReactSelect
                          label='Comparison'
                          options={triggerComparisons}
                          handleFilter={handleComparisonChange}
                          placeholder={<div>Select </div>}
                          selectedOption={triggerComparisons.find(
                              o => o.value === selected.operator
                          )}
                      />
                  </Grid>
                  <Grid item xs={4}>
                      <label>
                          <Typography className='metrics-dropdown-title'>Value</Typography>

                      </label>
                      <input
                          className='custom-text-field text-sm-regular'
                          type='text'
                          placeholder='Enter value'
                          value={selected.value || ''}
                          onChange={handleValueChange}
                      />
                  </Grid>
              </Grid>
          </Box>
      </Box>
      </Box>
  )
}

export default QueryBuilders